var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretNeutral(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "caret-neutral_svg__ionicon",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404 339.178l-139.78 163.12a24 24 0 01-36.44 0L88 339.178c-13.34-15.57-2.28-39.62 18.22-39.62h279.6c20.5 0 31.56 24.05 18.18 39.62zm0-167.238L264.22 8.82a24 24 0 00-36.44 0L88 171.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretNeutral);
export default __webpack_public_path__ + "static/media/caret-neutral.996b81ff56f7808d2805f7620e768855.svg";
export { ForwardRef as ReactComponent };